import React, { useState } from "react";
import classNames from "classnames";

import { Plate } from "../helpfull/Plate";
import { AnalyticsButton } from "../helpfull/AnalyticsButton";
import { HeaderTitle } from "../helpfull/HeaderTitle";
import { TinyButton } from "../helpfull/TinyButton";
import { useDesktopMobile } from "../../hooks/useDesktopMobile";

import headingIcon from "./assets/heading-icon.svg";

import BEM from "./GoogleTasksEmbeeded.module.scss";

export const GoogleTasksEmbeeded = () => {
  const [isUnFolded, setIsUnFolded] = useState(false);

  const foldClickHandler = () => setIsUnFolded(!isUnFolded);

  const title = (
    <a
      className={BEM.title}
      target="_blank"
      href={useDesktopMobile(
        "https://tasks.google.com/embed/?origin=https://calendar.google.com&fullWidth=1",
        "https://play.google.com/store/apps/details?id=com.google.android.apps.tasks"
      )}
    >
      Google Tasks
    </a>
  );

  return (
    <Plate customClassName={BEM.plate}>
      <article className={BEM.BLOCK}>
        <header className={BEM.header}>
          <HeaderTitle title={title} icon={headingIcon} />
          <TinyButton onClick={foldClickHandler} className={BEM.tinyBtn}>
            {isUnFolded ? "Fold" : "Unfold"}
          </TinyButton>
          {/* <AnalyticsButton /> */}
        </header>
        <main
          className={classNames({
            [BEM.embeedUpperContainer]: true,
            [BEM.embeedUpperContainer___unfolded]: isUnFolded,
          })}
        >
          <div className={BEM.embeedInnerContainer}>
            <embed
              src="https://tasksboard.com/app"
              className={BEM.embeed}
            ></embed>
          </div>
        </main>
      </article>
    </Plate>
  );
};
